import * as yup from "yup";

export type MergeListingsValidationType = yup.InferType<typeof MergeListingsValidation>;

export const MergeListingsValidation = yup.object().shape({
	section: yup.string().required(""),
	row: yup.string().required(""),
	price: yup.string().required(""),
	firstSeatNumber: yup.string().required("").max(6, ""),
});
